import React from "react";
import PropTypes from "prop-types";
import "../../styles/TextArea.scss";
import ErrorMessage from "../error-message/ErrorMessage";

const TextArea = (props) => {
    const { label, placeholder, rows, cols, disabled, name, fieldRegister, errorMessage, maxLength, handleChange, handleBlur } = props;
    return (
        <React.Fragment>
            {label && <label className="required">{label}</label>}
            <textarea
                data-testid={name}
                className="textarea"
                rows={rows}
                cols={cols}
                placeholder={placeholder}
                disabled={disabled}
                onChange={handleChange}
                onBlur={handleBlur}
                name={name}
                maxLength={maxLength}
                {...fieldRegister}
            ></textarea>
            {errorMessage && <ErrorMessage error={errorMessage} />}
        </React.Fragment>
    )
}

TextArea.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
    cols: PropTypes.number,
    maxLength: PropTypes.number
}

export default TextArea;